import defaultState from '@/store/telegram/state'

export default {
  setTelegramBotInfo(state, value) {
    state.vtMarketsBot = value
  },
  setTelegramId(state, value) {
    state.telegramId = value
  },
  setUsername(state, value) {
    state.username = value
  },
  setTgBindingStatus(state, value) {
    state.tgBindingStatus = value
  },
  setResBind(state, value) {
    state.resBind = value
  },
  setTelegramParams(state, value) {
    state.telegramParams = value
  },
  setTgBtn(state, value) {
    state.tgBtn = value
  },
  setTelegramToRouterPath(state, value) {
    state.telegramToRouterPath = value
  },
  setTelegramCampaignCode(state, value) {
    state.telegramCampaignCode = value
  },
  setTgLinks(state, value) {
    state.tgLinks = value
  },
  setTgOriPath(state, value) {
    state.tgOriPath = value
  },
  setSkipResetTgLink(state, value) {
    state.skipResetTgLink = value
  },
  setSidebarMenu(state, value) {
    state.sidebarMenu = value
  },
  setSidebarMenuActive(state, value) {
    state.sidebarMenuActive = value
  },
  reset(state) {
    Object.assign(state, defaultState)
  },
}
